import Vue from 'vue'
const dragEventBus = new Vue()
export default dragEventBus
